import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import './plugins/marquee-text';
import './plugins/lodash';
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'


Vue.config.productionTip = false

const socketConnection = SocketIO('https://api.theme-lab.com', {
  transports: ["websocket"],
  withCredentials: true,
});

Vue.use(new VueSocketIO({
  debug: false,
  //connection: 'https://api.theme-lab.com',

  connection: socketConnection,
  //connection: 'http://localhost:3001',
  //reconnectionAttempts : 10,
  //reconnectionDelay : 3000,
  //reconnectionDelayMax : 5000,
  //timeout: 5000,
  //autoConnect: false,
}))

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
